module.exports = __webpack_public_path__ + "static/media/linkedin.86558dc5.svg";